module.exports = __webpack_public_path__ + "static/media/gelaende_boe.d005a959.jpeg";